import { useState, useEffect, useContext } from 'react'
import EnvContext from '../../context/EnvContext'
import UserContext from '../../context/UserContext';
import { gql, useQuery } from '@apollo/client';
import * as moment from "moment-timezone"

const BOUNCER_DIAGNOSTICS_QUERY = gql`
query($envName: String!) {
    diagnostics(
        where: {
            env: {_eq: $envName }, 
            type: {_eq: "bouncer"}
        }, order_by: {timestamp: desc}) {
      output
      timestamp
      name
    }
  }
`

export const useBouncerDiagnostics = () => {
    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(BOUNCER_DIAGNOSTICS_QUERY,{ variables: { envName: envSelected }, pollInterval: 5000 })

    useEffect(() => {
        let bouncerCluster = {}
        if (!loading && data && data.diagnostics && data.diagnostics.length > 0) {
            data.diagnostics.forEach(b => {
                let diagnosticsDataCopy = {}
                Object.assign(diagnosticsDataCopy, b.output)
                diagnosticsDataCopy["clusterName"] = b.name
                bouncerCluster[b.name] = diagnosticsDataCopy
            })
        }

        setLookupData(bouncerCluster)

    }, [data, loading])

    return lookupData
}

export const useBouncerDiagnosticsTimestamp = () => {    
    const envSelected = useContext(EnvContext)
    const token = useContext(UserContext)

    const [lookupData, setLookupData] = useState(null)
    const { data, loading } = useQuery(BOUNCER_DIAGNOSTICS_QUERY,{ variables: { envName: envSelected }, pollInterval: 5000 })

    useEffect(() => {
         let timestampTemp = null
         if (!loading && data && data.diagnostics && data.diagnostics.length > 0) {
             timestampTemp = data.diagnostics[0].timestamp
             timestampTemp = moment(moment(timestampTemp).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
             timestampTemp = moment(timestampTemp).tz(token.timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
             setLookupData(timestampTemp)
         }
    }, [loading, data, token, token.timezone])

    return lookupData
}

export const useBouncerDiagnosticsStatus = (serviceGroupSelected) => {    
    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState(false)
    const shouldSkip = serviceGroupSelected === "bouncer" ? false : true
    const { data, loading } = useQuery(BOUNCER_DIAGNOSTICS_QUERY,{ variables: { envName: envSelected }, pollInterval: 15000, skip: shouldSkip })

    useEffect(() => {
        let diagnosticAlert = false
        if (!loading && data && data.diagnostics && data.diagnostics.length > 0) {
            data.diagnostics.forEach(b => {
                if (!b.name.includes("readonly")) {
                    let diagnosticData = b.output
                    if (diagnosticData.alert) {
                        diagnosticAlert = true
                    }
                }
            })
        }
        setLookupData(diagnosticAlert)

    }, [data, loading])


    return lookupData
}

